import React from "react"
import styles from "./styles.scss"

class Tooltip extends React.Component {
  render() {
    const { children, text, ...rest } = this.props

    return (
      <div className={styles.tooltip} {...rest}>
        {children}
        <span className={styles.tooltipText}>{text}</span>
      </div>
    )
  }
}

export default Tooltip



// WEBPACK FOOTER //
// ./src/pages/LandingPage/Chart/DiagonalLine/Step/Tooltip/index.jsx